/**
 * Created by Carsten Bühler
 * User: CBuehler on 05.11.2015
 * Copyright: xdot GmbH 2015
 */
'use strict';

import WebSocketStateWindow from '../components/WebSocketStateWindow';
import webstomp from 'webstomp-client';

const SOCKET_BASE_URL = (location.origin + '/o/websocket-endpoint/socket')
    .replace('https', 'wss')
    .replace('http', 'ws');

const WS_READYSTATE = ['CONNECTING', 'OPEN', 'CLOSING', 'CLOSED'];

class DataEventSocketStomp {

    constructor(options){
        this.url = SOCKET_BASE_URL;
        this.options = options;
        this.reconnectCount = 0;
        this.socket = {};
        this.registeredTopics = {};
        this.subscription = null;
        this.init(options);

        this.stateWindowInterval = setInterval(() => {
            const { connected, ws, serverActivity } = this.socket;
            WebSocketStateWindow({ connected, wsReadyState: WS_READYSTATE[ws.readyState], serverActivity });
        }, 5000);
    }

    init({ onMessageCb }){
        this.socket = webstomp.client(this.url);
        this.socket.onMessage = msg => {
            let message = JSON.parse(msg.body);
            if (message.eventType || message.metric || Array.isArray(message)) {
                console.log('Websocket Update-Message', message);
                onMessageCb(message);
            } else {
                console.warn('Unknown Websocket-Message', message);
            }
        };
    }

    registerTopics(classNames /*one or array*/){
        this.modifyRegistered(classNames);
    }

    deregisterTopic(classNames /*one or array*/){
        this.modifyRegistered(classNames, false);
    }

    modifyRegistered(classNames, add = true){
        //socket.push(JSON.stringify({ type: 'registerTopic', topic: className }));
        let changed = [];
        classNames = Array.isArray(classNames) ? classNames : [classNames];
        classNames.forEach(c => {
            if (add && !this.registeredTopics[c]) {
                this.registeredTopics[c] = true;
                changed.push(c);
            } else if (!add && this.registeredTopics[c]) {
                delete this.registeredTopics[c];
                changed.push(c);
            }
        });

        if (changed.length > 0) {
            console.log(add ? 'Add Topics' : 'Remove Topics', changed, 'now registered', this.registeredTopics);
            if (this.socket.connected) {
                this.subscription = this.socket.subscribe('/data-event-bus', this.socket.onMessage, { classNames: Object.keys(this.registeredTopics) });
            } else {
                console.warn('WS this.socket not connected!');
                //this.scheduleReconnect();
            }
        }
    }

    connect(onConnect){
        if (this.isConnected()) {
            return this.socket;
        } else {
            this.socket.connect({ host: location.host },
                () => {
                    console.log('Connect ', this.socket);

                    if (Object.keys(this.registeredTopics).length > 0) {
                        const topics = Object.keys(this.registeredTopics);
                        this.registeredTopics = {};
                        this.registerTopics(topics);
                    }
                    clearTimeout(this.reconnectTimer);
                    delete this.reconnectTimer;
                    this.reconnectCount = 1;
                    onConnect && onConnect();
                },
                error => {
                    console.error('Connect error', error, this.socket);
                    clearTimeout(this.reconnectTimer);
                    delete this.reconnectTimer;
                    this.connectPromise = null;
                    this.scheduleReconnect();
                }
            );
        }

        return this.socket;
    }

    scheduleReconnect(){
        if (!this.reconnectTimer) {
            clearInterval(this.stateWindowInterval);
            this.init(this.options);
            const MIN = 1000 * 60;
            this.reconnectCount++;
            const waitTime = Math.min((Math.pow(2, this.reconnectCount) * 500), 2 * MIN + (Math.random() * MIN));
            console.log('Schedule ' + this.reconnectCount + ' reconnect in ' + waitTime + 'ms');
            this.reconnectTimer = setTimeout(() => this.connect(), waitTime);
        }
    }

    isConnected(){
        return this.socket.connected;
    }

    disconnect(s){
        this.subscription.unsubscribe({});
    }
}

export default DataEventSocketStomp;




// WEBPACK FOOTER //
// ./js/socket/data-event-socket-stomp.js